import React, { Fragment, Suspense } from 'react';

import {
  GOOGLE_TAG_MANAGER_ENVS,
  GOOGLE_TAG_MANAGER_ID,
} from '../../constants/config';
import { GoogleTagManager } from './GoogleTagManager/GoogleTagManager';
import { Hotjar } from './Hotjar/Hotjar';

const Analytics = () => {
  const isProdEnv = GOOGLE_TAG_MANAGER_ENVS.includes(window.location.hostname);

  if (!isProdEnv) {
    return null;
  }

  return (
    <Suspense fallback={<Fragment></Fragment>}>
      <GoogleTagManager siteId={GOOGLE_TAG_MANAGER_ID} />
      <Hotjar />
    </Suspense>
  );
};

export { Analytics };
